<template>
  <div class="q-px-sm q-py-xs rounded bg-warning">
    {{ helper.message }}
  </div>
</template>

<script>
export default {
  name: 'HelperWarningMessage',
  props: {
    helper: {
      type: Object,
      default () {
        return { message: '', state: 'inactive' }
      }
    }
  }
}
</script>
